export default __webpack_public_path__ + "6f618ce8343f26c6ea38df9b02ab4c53.png";